import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Select, Input, Textarea, Checkbox } from 'components/fields'
import { MaterialModal } from 'components/layout'
import { InfoSMARTModal, InfoAssessorModal } from 'components/modals'
import { Note, Title, InfoBubble } from 'components/misc'
import {
  SUBCATEGORIES,
  SUBCATEGORIES_INTL
} from 'constants/layout/setup-activity'
import MODALS from 'constants/layout/modals'
import { apiCodeLists, apiConfiguration, apiDashboard, apiAssessors } from 'helpers/decorators/api'
import { mapCategories } from 'helpers/mapForSelect'
import { modal, form } from 'helpers/decorators'
import validate from './setup-activity.validation'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { connect } from 'react-redux'
import styles from './setup-activity.styl'
import assessorsDropdownSelector from '../../../../redux/selectors/assessors/assessorsDropdownSelector'
import DownloadButton from '../../../misc/DownloadButton/DownloadButton'



const asyncValidate = (val, dispatch, props) => {
  const { values } = props

  const isAssessorManagementEnabled = get(props, `configuration.values.${CONFIGURATION_KEYS.isAssessorManagementEnabled.id}.booleanValue`)

  const setupAssessorId = get(values, 'setupAssessorId')

  if (!isAssessorManagementEnabled || setupAssessorId !== 0) {
    return new Promise(resolve => resolve())
  }

  if (!get(values, 'assessorEmail')) {
    return new Promise(resolve => resolve())
  }

  const email = get(values, 'assessorEmail')

  const orgId = get(props, 'dashboard.awards.awards.data.organization.id')

  const activityCategoryId = get(values, 'helpers.subcategory')

  return email && orgId && activityCategoryId && props.checkAssessorEmailAvailability(email, orgId, activityCategoryId)
    .then(body => {
      if (!get(body, 'body.available')) {
        const bodyObj = get(body, 'body')

        let assessor = ''

        get(bodyObj, 'assessorList').forEach(a => {
          assessor += get(a, 'name') + ' '
        })
        // eslint-disable-next-line
        throw {
          assessorEmail:
              {
              text: `Assessor ${assessor} already exists, select him/her from the list.`,
              intlKey: 'errors.assessor_already_exists'
            }

        }
      }
    })
}

@apiConfiguration()
@injectIntl
@apiDashboard.apiActivity({ loaders: ['setup'] })
@apiAssessors()
@apiCodeLists(['titles'], { public: true })
@connect(({ api }) => ({
  dashboard: api.dashboard,
  assessor: api.assessor
}))
@form({
  form: 'setupActivity',
  disableHook: true,
  validate,
  asyncValidate
})
@modal.trigger()
class SetupActivity extends Component {
  static propTypes = {
    awardId: PropTypes.number,
    mustBeMajor: PropTypes.bool,
    isSimplifiedBronze: PropTypes.bool.isRequired,
    modalData: PropTypes.object,
    showMajor: PropTypes.bool,
    onGetActivityCategories: PropTypes.func.isRequired,
    onGetConfigurationValue: PropTypes.func.isRequired,
    onSetupActivity: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    nestedModal: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    activityCategories: PropTypes.object,
    setupStatus: PropTypes.object,
    codeLists: PropTypes.object,
    activity: PropTypes.object,
    values: PropTypes.object,
    intl: PropTypes.object,
    colorClass: PropTypes.string,
    onCreateActivity: PropTypes.func,
    onGetAvailableAssessorsForActivityCategory: PropTypes.func.isRequired,
    assessor: PropTypes.object
  }

  componentWillMount = async () => {
    await Promise.all([
      this.props.onGetActivityCategories(),
      this.props.onGetConfigurationValue(
        CONFIGURATION_KEYS.assessorMandatory.id,
        this.getOrgId(),
        true
      ),
      this.props.onGetConfigurationValue(
        CONFIGURATION_KEYS.assessorWelcomeEmail.id,
        this.getOrgId(),
        true),

      this.props.onGetConfigurationValue(
        CONFIGURATION_KEYS.isAssessorManagementEnabled.id,
        this.getOrgId(),
        true)
    ])
    const orgId = this.getOrgId()
    const subCategoryValue = this.getSubcategoryValue()

    if (orgId && subCategoryValue && subCategoryValue !== 'others') {
      this.props.onGetAvailableAssessorsForActivityCategory(orgId, subCategoryValue)
    }
  }

  handleSubmit = fields => {
    const isAdditional = get(this.props.modalData, 'isAdditional', false)
    const activityId = get(this.props.modalData, 'activityId', null)

    if (isAdditional === true) {
      const activitySection = get(
        this.props,
        'activityOverview.data.activitySection.value'
      )

      return this.props.onCreateActivity(this.props.awardId, fields, {
        resetForm: this.props.reset,
        activitySection,
        activityId
      })
    }

    return this.props.onSetupActivity(get(this.props.activity, 'id'), fields, {
      resetForm: this.props.reset,
      activitySection: get(this.props.activity, 'activitySection')
    })
  }

  clearSubCategory = () => {
    this.props.change('assessorId', null)
    this.props.change('helpers.subcategory', null)
  }

  onSubCategoryChange = (subCategoryId, isAssessorManagementEnabled) => {
    const orgId = this.getOrgId()

    if (isAssessorManagementEnabled && subCategoryId && subCategoryId !== 'others' && orgId) {
      this.props.onGetAvailableAssessorsForActivityCategory(orgId, subCategoryId)
    }

    this.props.change('helpers.others', null)
    this.props.change('assessorId', null)
  }

  getOrgId() {
    return get(this.props, 'dashboard.awards.awards.data.organization.id')
  }
  getSubcategoryValue() {
    return get(this.props, 'values.helpers.subcategory')
  }

  handleOpen = () => this.props.nestedModal(MODALS.INFO_SMART_MODAL)

  handleOpenAssessor = () => this.props.nestedModal(MODALS.INFO_ASSESSOR)

  render() {
    const {
      values,
      activity,
      codeLists,
      isSimplifiedBronze,
      showMajor,
      colorClass,
      mustBeMajor,
      setupStatus,
      handleSubmit,
      activityCategories,
      intl,
      awardId,
      assessor
    } = this.props

    const isAssessorManagementEnabled = get(this.props,
      `configuration.values.${CONFIGURATION_KEYS.isAssessorManagementEnabled.id}.booleanValue`)

    const assessorWelcomeEmail = get(this.props,
      `configuration.values.${CONFIGURATION_KEYS.assessorWelcomeEmail.id}.booleanValue`)

    const categoryValue = get(values, 'helpers.category')

    const subcategoryValue = get(values, 'helpers.subcategory')
    const isOthersSubCategory = subcategoryValue === 'others'
    const needHelpFromAwardLeader = get(values, 'setupAssessorId') === -1
    const isNoneOfTheseSubCategory = get(values, 'setupAssessorId') === 0
    const dropdownAssessors = assessorsDropdownSelector(assessor, isOthersSubCategory, this.props)
    const showAssessorFields = !isAssessorManagementEnabled || ((isAssessorManagementEnabled && !isOthersSubCategory) && (isAssessorManagementEnabled && !needHelpFromAwardLeader) && (isAssessorManagementEnabled && isNoneOfTheseSubCategory))

    const activitySection =
      get(activity, 'activitySection.value') ||
      get(this.props, 'activityOverview.data.activitySection.value')
    const categories = get(
      activityCategories,
      `['${activitySection}'].categories`
    )
    const subCategories = get(
      activityCategories,
      `['${activitySection}'].subCategories`
    )
    const categoriesOptions = categories && mapCategories(categories)
    const subCategoriesOptions = subCategories && categoryValue
      ? mapCategories(subCategories[categoryValue])
      : []

    subCategoriesOptions.push(SUBCATEGORIES_INTL(intl))

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>


        {isAssessorManagementEnabled && <Note hideNodePrefix>
          <FormattedMessage
            id="label.assessor_detaiL_setup_activity_desc"
            defaultMessage="Your selected proposed activity and assessor has been shared with your Award Leader for authorisation that they are suitable for your Award. Your Award Leader will approve or revise the selection – either way you will receive a notification once it has been actioned. Until the activity and assessor are approved, and the assessor agrees to assess you, you are not able to enter any logs."
          />
        </Note>}

        <Title h5 colorClass={colorClass}>
          <FormattedMessage
            id="formTitle.activity_details"
            defaultMessage="Activity Details"
          />
        </Title>

        <div className="row">
          <div className="col-xs-12">
            <Select
              options={categoriesOptions}
              name="helpers.category"
              intlKey="label.category"
              label="Category"
              onChange={this.clearSubCategory}
            />
          </div>
        </div>

        {categoryValue &&
          <div className="row">
            <div className="col-xs-12">
              <Select
                options={subCategoriesOptions}
                name="helpers.subcategory"
                intlKey="label.subcategory"
                label="Subcategory"
                onChange={subCategoryId => this.onSubCategoryChange(subCategoryId, isAssessorManagementEnabled)}
              />
            </div>
          </div>}

        {subcategoryValue === SUBCATEGORIES.others.value &&
          <div className="row">
            <div className="col-xs-12">
              <Input
                name="helpers.others"
                label="Please specify your category"
                intlKey="label.specify_category"
                maxLength={512}
              />
            </div>
          </div>}

        <div className="row">
          <div className="col-xs-12">
            <div style={{ paddingRight: '45px' }}>
              <Textarea
                rows={3}
                resizeable
                name="aim"
                label="Goal"
                intlKey="label.goal"
              />
            </div>

            <div style={{ position: 'absolute', right: '23px', top: '28px' }}>
              <InfoBubble onClick={this.handleOpen} />
            </div>
          </div>
        </div>

        <Title h5 colorClass={colorClass}>
          <FormattedMessage
            id="formTitle.assessor_details"
            defaultMessage="Assessor Details"
          />

          <span style={{ marginLeft: '10px' }}>
            <InfoBubble onClick={this.handleOpenAssessor} />
          </span>
        </Title>

        {assessorWelcomeEmail && !isAssessorManagementEnabled &&
          <div className={styles.assessorInfoDownload}>
            <DownloadButton
              url={`/documents?entity=award&entityId=${awardId}&output=pdf&configName=WELCOME_EMAIL_A`}
              apiParams
              secondary
              link
            >
              <FormattedMessage
                id="button.download_info_for_assessor"
                defaultMessage="Download info for assessor"
              />
            </DownloadButton>
          </div>
        }

        {isAssessorManagementEnabled && <div>
          {!isOthersSubCategory && !needHelpFromAwardLeader && <div className={styles.selectAssessor} ><FormattedMessage
            id="label.select_award_unit_assessor"
            defaultMessage="Select from assessors already approved by your Award Unit or create a new one below."
          /></div>}


          {isOthersSubCategory && <div className={styles.assessorIsDisabled}><FormattedMessage
            id="label.assessor_disabled_for_other_activity"
            defaultMessage="Assessor selection is disabled for other activity."
          /></div>}

          {!isOthersSubCategory && <div className="row">
            <div className="col-xs-12">
              <Select
                name="setupAssessorId"
                label=""
                intlKey=""
                options={dropdownAssessors}
                disabled={!subcategoryValue}
              />
            </div>
          </div>}
        </div>}

        {showAssessorFields && <div>
        <div className="row">
          <div className="col-xs-12">
            <Select
              name="assessorTitle"
              label="Title"
              intlKey="label.title"
              options={get(codeLists, 'titles.list')}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Input name="assessorName" label="Name" intlKey="label.name" maxLength={100} />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Input
              name="assessorEmail"
              label="Email"
              type="email"
              intlKey="label.email"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Input
              name="assessorPhone"
              label="Phone"
              intlKey="label.phone"
            />
          </div>
        </div>

          {isNoneOfTheseSubCategory && <div className="row">
            <div className="col-xs-12">
              <Note >
                <FormattedMessage
                  id="label.assessor_relevant_exp_desc"
                  defaultMessage="To help your Award Leader decide if this person is a viable Assessor, please provide some information about their experience in this activity e.g. coach."
                />
              </Note>
              <Textarea
                name="assessorRelevantExperience"
                label="Relevant Experience"
                intlKey="label.relevant_experience"
                maxLength={200}
              />

            </div>
          </div>}
        </div>}

        {(showMajor && !isSimplifiedBronze) &&
          <div className="row">
            <div className="col-xs-12">
              <Checkbox
                name="isMajor"
                label="Choose as Major activity"
                intlKey="label.choose_as_major_activity"
                disabled={mustBeMajor}
              />

              <Note intlKey="label.major_activity_means_that_you_have_to_spent">
                <FormattedMessage
                  id="label.major_activity_means_that_you"
                  defaultMessage="Major activity means that you have to spent twice much time on this activity compare to other."
                />
              </Note>
            </div>
          </div>}

        <InfoSMARTModal />
        <InfoAssessorModal />

        <MaterialModal.Footer
          action="Setup"
          actionKey="button.setup"
          colorClass={colorClass}
          insideContent
          isLoading={get(setupStatus, 'loading')}
        />
      </form>
    )
  }
}

export default SetupActivity
